import { reemplazarUrl } from "helpers/functions";
import { antecedentesApi } from "../view/antecedentes.service";

export const createAntecedente = antecedentesApi.injectEndpoints({
  endpoints: (builder) => ({
    createAntecedente: builder.mutation({
      query: (data) => {
        const { estudiante, ...rest } = data;
        const newURLv1 = reemplazarUrl(estudiante, 1);
        const finalObject = { estudiante: newURLv1, ...rest };
        return {
          url: "/v1/api/antecedenteacademico/",
          method: "POST",
          body: finalObject,
        };
      },
      invalidatesTags: [{ type: "Antecedentes", id: "LIST" }],
    }),
  }),
});

export const { useCreateAntecedenteMutation } = createAntecedente;
